import 'htmx.org';
import Alpine from 'alpinejs';

import '../components/alpine/tabs';
import '../components/strecha/alpine/roof';
import '../components/strecha/alpine/sectionScene';
import '../components/strecha/alpine/purlinScene';
import '../components/strecha/alpine/sandwich';
import '../components/strecha/alpine/climateLoads';
import '../components/strecha/alpine/results';

window.Alpine = Alpine;
Alpine.start();

window.htmx = require('htmx.org');

import '../components/strecha/roof';
import '../components/climaMap';

import '@iframe-resizer/child';
